import { ExternalInvitation } from '@/domain/external-invitation/entities/external-invitation.entity';
import { selectProjectFestivalItems } from '@/domain/project-festival/project-festival.selectors';
import { selectProjectTourItems } from '@/domain/project-tour/project-tour.selectors';
import { selectProjectVenuesItems } from '@/domain/project-venue/project-venue.selectors';
import { createAppAsyncThunk } from '@/domain/store.thunk';

type Params = void;

type Result = ExternalInvitation[];

export const getExternalInvitationSurveys = createAppAsyncThunk(
  'externalInvitationSurvey/getExternalInvitationSurveys',
  // here i will start by looping on loaded project in redux
  // possible improvement : get all surveys for organisation
  async (
    _params: Params,
    { getState, extra: { externalInvitationGateway } },
  ): Promise<Result> => {
    const state = getState();
    const projectIds = [
      ...selectProjectFestivalItems(state),
      ...selectProjectTourItems(state),
      ...selectProjectVenuesItems(state),
    ].map((p) => p.id);
    const results = await Promise.all(
      projectIds.map((id) => externalInvitationGateway.getInvitations(id)),
    );
    let invitations = results.flat();
    invitations = invitations.filter(
      (x) => x.scope === 'SURVEY-MOBILITY-ACCOMMODATION',
    );
    return invitations;
  },
);
